module.exports = "/_next/static/images/game-2-intro-uv-tutorial1-e778ef29a0b0d36febe1ba1781fe85f5.png";